
import React from "react";

import member1 from "../../assets/LM1.png";
import member2 from "../../assets/LM2.png";
import member3 from "../../assets/LM3.png";
import member4 from "../../assets/LM4.png";
import member5 from "../../assets/LM5.png";
import member6 from "../../assets/LM6.png";
import member7 from "../../assets/LM7.png";

import "./Home.css";

const Home = () => {
  const today = new Date().toLocaleDateString();

  const lifetimeMembers = [
    {
      name: "Faiz Ahmed Faiz",
      designation: "Founder, Ghalib Library",
      image: member1,
    },
    {
      name: "Mirza Zafar-ul-Hasan",
      designation: "Founder Secretary, Ghalib Library",
      image: member2,
    },
    {
      name: "Dr. Sabih-ud-din Rehmani",
      designation: "Lifetime Member",
      image: member3,
    },
    {
      name: "Sarwar Ghazali",
      designation: "Lifetime Member",
      image: member4,
    },
    {
      name: "Abdul Aziz Khan Aziz Ahsan",
      designation: "Lifetime Member",
      image: member5,
    },
    {
      name: "Prof. Dr. Tanzeem-ul-Firdous",
      designation: "Lifetime Member",
      image: member6,
    },
    {
      name: "Dr. Anees Fatima",
      designation: "Lifetime Member",
      image: member7,
    },
  ];

  return (
    <div className="home-container">

      {/* ================= HERO ================= */}

      <section className="home-hero">

        <div className="hero-content">

          <span className="hero-small-title">
            GHALIB LIBRARY
          </span>

          <h1>
            A Place Where
            <br />
            <span>Knowledge Lives.</span>
          </h1>

          <p>
            Explore our collection of books, discover new ideas,
            connect with literature, and experience a peaceful
            environment dedicated to learning and research.
          </p>

          <div className="hero-date">
            <span>📅</span>
            <span>Today: {today}</span>
          </div>

        </div>

        <div className="hero-decoration">
          <div className="hero-book-icon">
            📚
          </div>

          <div className="hero-decoration-line"></div>

          <p>
            Read. Learn. Discover.
          </p>
        </div>

      </section>


      {/* ================= INTRO ================= */}

      <section className="intro-section">

        <div className="intro-label">
          ABOUT OUR LIBRARY
        </div>

        <h2>
          A Home for Readers,
          <br />
          Researchers & Learners
        </h2>

        <p>
          Ghalib Library provides a welcoming space for readers,
          students, researchers and literature enthusiasts. Our
          collection brings together academic knowledge, literature,
          history, science and recreational reading in one place.
        </p>

      </section>


      {/* ================= SERVICES ================= */}

      <section className="services-section">

        <div className="section-heading-row">

          <div>
            <span className="section-label">
              WHAT WE OFFER
            </span>

            <h2>
              Explore Our Library
            </h2>
          </div>

          <div className="heading-line"></div>

        </div>


        <div className="services-list">

          <div className="service-item">

            <div className="service-number">
              01
            </div>

            <div className="service-icon">
              📖
            </div>

            <div className="service-content">
              <h3>
                Browse Books
              </h3>

              <p>
                Explore books by title, author, genre and language
                and discover something new to read.
              </p>
            </div>

            <div className="service-arrow">
              →
            </div>

          </div>


          <div className="service-item">

            <div className="service-number">
              02
            </div>

            <div className="service-icon">
              📅
            </div>

            <div className="service-content">
              <h3>
                Library Events
              </h3>

              <p>
                Stay informed about seminars, workshops,
                book fairs and other library activities.
              </p>
            </div>

            <div className="service-arrow">
              →
            </div>

          </div>


          <div className="service-item">

            <div className="service-number">
              03
            </div>

            <div className="service-icon">
              📚
            </div>

            <div className="service-content">
              <h3>
                Digital Collection
              </h3>

              <p>
                Discover an extensive collection of academic,
                literary and recreational books.
              </p>
            </div>

            <div className="service-arrow">
              →
            </div>

          </div>


          <div className="service-item">

            <div className="service-number">
              04
            </div>

            <div className="service-icon">
              🏛️
            </div>

            <div className="service-content">
              <h3>
                Peaceful Environment
              </h3>

              <p>
                Enjoy a quiet and comfortable environment
                designed for reading, learning and research.
              </p>
            </div>

            <div className="service-arrow">
              →
            </div>

          </div>

        </div>

      </section>


      {/* ================= LIBRARY HIGHLIGHTS ================= */}

      <section className="highlights-section">

        <div className="highlight-heading">

          <span className="section-label">
            BY THE NUMBERS
          </span>

          <h2>
            Library Highlights
          </h2>

        </div>


        <div className="highlight-grid">

          <div className="highlight-item">
            <strong>5000+</strong>
            <span>Books</span>
          </div>

          <div className="highlight-item">
            <strong>30+</strong>
            <span>Genres</span>
          </div>

          <div className="highlight-item">
            <strong>1000+</strong>
            <span>Members</span>
          </div>

          <div className="highlight-item">
            <strong>50+</strong>
            <span>Events</span>
          </div>

        </div>

      </section>


      {/* ================= LIFETIME MEMBERS ================= */}

      <section className="members-section">

        <div className="members-header">

          <span className="section-label">
            OUR COMMUNITY
          </span>

          <h2>
            Lifetime Members
          </h2>

          <p>
            Honoring the distinguished individuals who have
            contributed to the establishment, development and
            intellectual legacy of Ghalib Library.
          </p>

        </div>


        <div className="members-grid">

          {lifetimeMembers.map((member, index) => (

            <div
              className="member-card"
              key={index}
            >

              <div className="member-image-wrapper">

                <img
                  src={member.image}
                  alt={member.name}
                />

              </div>

              <div className="member-info">

                <h3>
                  {member.name}
                </h3>

                <p>
                  {member.designation}
                </p>

              </div>

            </div>

          ))}

        </div>

      </section>


      {/* ================= LIBRARY RULES ================= */}

      <section className="rules-section">

        <div className="rules-left">

          <span className="section-label">
            PLEASE REMEMBER
          </span>

          <h2>
            Library Rules
          </h2>

          <p>
            Help us maintain a peaceful and respectful
            environment for everyone.
          </p>

        </div>


        <div className="rules-right">

          <div className="rule">
            <span>01</span>
            <p>
              📚 Maintain silence inside the library.
            </p>
          </div>

          <div className="rule">
            <span>02</span>
            <p>
              📱 Keep mobile phones on silent mode.
            </p>
          </div>

          <div className="rule">
            <span>03</span>
            <p>
              📖 Handle books carefully.
            </p>
          </div>

          <div className="rule">
            <span>04</span>
            <p>
              🪪 Carry your library membership card.
            </p>
          </div>

          <div className="rule">
            <span>05</span>
            <p>
              ⏰ Return borrowed books on time.
            </p>
          </div>

        </div>

      </section>


      {/* ================= QUOTE ================= */}

      <section className="quote-section">

        <div className="quote-mark">
          “
        </div>

        <blockquote>
          A reader lives a thousand lives
          before he dies.
        </blockquote>

        <div className="quote-author">
          — George R. R. Martin
        </div>

      </section>

    </div>
  );
};

export default Home;
